// Generated by `bazel run i18n`. Do not edit by hand.
import orderSummary_5f9c32fd from "./en/email--content--src--blocks--order-summary.json";
import blocks_6308d793 from "./en/email--content--src--blocks.json";
import src_808cdba4 from "./en/email--ssr--src.json";
import src_827cc5a7 from "./en/email--templates--src.json";
import returnShipping_1e622799 from "./en/return--core--backend--src--return-shipping.json";
import src_875a4273 from "./en/return--core--backend--src.json";
import src_c04810b6 from "./en/return--shipping--common--src.json";
import returnTimeline_f80a6a4d from "./en/src--return-timeline.json";
import src_c1a2d0b5 from "./en/src.json";

export default Object.assign(
  {},
  orderSummary_5f9c32fd,
  blocks_6308d793,
  src_808cdba4,
  src_827cc5a7,
  returnShipping_1e622799,
  src_875a4273,
  src_c04810b6,
  returnTimeline_f80a6a4d,
  src_c1a2d0b5,
);
